export const brands = [
    'Toyota',
    'Nissan',
    'Jetour',
    'Mercedes',
    'Mitsubishi',
    "Suzuki",
    "Jeep",
    "Hyundai",
    "Honda"
]